module.exports = __webpack_public_path__ + "static/media/b4.be99f3ec.jpg";